
(function() {
  var result = { translations: { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206", "days": "{{ days }}\u65E5", "shortForm": { "seconds": "{{ seconds }}\u79D2", "minutes": "{{ minutes }}\u5206", "hours": "{{ hours }}\u6642\u9593", "days": "{{ days }}\u65E5", "hoursAndMinutes": "{{ hours }}\u6642\u9593{{ minutes }}\u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} Q{{quarterNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u3001\u5185\u7DDA{{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.787"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.787",
    "ar-eg": "static-7.787",
    "bg": "static-7.787",
    "bn": "static-7.787",
    "ca-es": "static-7.787",
    "cs": "static-7.787",
    "da": "static-7.787",
    "de": "static-7.787",
    "el": "static-7.787",
    "en-gb": "static-7.787",
    "en": "static-7.787",
    "es-mx": "static-7.787",
    "es": "static-7.787",
    "fi": "static-7.787",
    "fr-ca": "static-7.787",
    "fr": "static-7.787",
    "he-il": "static-7.787",
    "hr": "static-7.787",
    "hu": "static-7.787",
    "id": "static-7.787",
    "it": "static-7.787",
    "ja": "static-7.787",
    "ko": "static-7.787",
    "lt": "static-7.787",
    "ms": "static-7.787",
    "nl": "static-7.787",
    "no": "static-7.787",
    "pl": "static-7.787",
    "pt-br": "static-7.787",
    "pt-pt": "static-7.787",
    "ro": "static-7.787",
    "ru": "static-7.787",
    "sk": "static-7.787",
    "sl": "static-7.787",
    "sv": "static-7.787",
    "th": "static-7.787",
    "tl": "static-7.787",
    "tr": "static-7.787",
    "uk": "static-7.787",
    "vi": "static-7.787",
    "x-pseudo": "static-7.787",
    "zh-cn": "static-7.787",
    "zh-hk": "static-7.787",
    "zh-tw": "static-7.787"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.787'}); }
})();


